module.exports = __webpack_public_path__ + "static/okauto_logo_new_black-0e0729b57a8282e4c14c771289e63e5d.svg";